<template>
    <div id="v-safety-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main-box">
            <!-- 步骤 -->
            <div class="step">
                <img class="pic_bg" :src="$config.resource + 'db_bjt.png'" alt="">
                <div class="row_box">
                    <div class="row curr">
                        <div class="circle">1</div>
                        <p>知识产权调查表</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">2</div>
                        <p>信息安全调查表</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">3</div>
                        <p>附件</p>
                    </div>
                </div>
            </div>
            <!-- 信息系统管理情况 -->
            <div class="alike alike_one">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>信息系统管理情况</p>
                </div>
                <dl>
                    <dt>
                        <p>人</p>
                        <div class="flex-1"></div>
                        <p>员</p>
                        <div class="flex-1"></div>
                        <p>管</p>
                        <div class="flex-1"></div>
                        <p>理:</p>
                    </dt>
                    <dd>
                        <div class="row_box">
                            <div class="tt">岗位信息安全和保密责任制度：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:duty == 1}" @click="onDuty(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="duty!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="duty==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已建立</p>
                                </div>
                                <div class="unify" :class="{curr:duty == 2}" @click="onDuty(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="duty!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="duty==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未建立</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">重要岗位人员信息安全和保密协议：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:agreement == 1}" @click="onAgreement(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="agreement!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="agreement==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>全部签订</p>
                                </div>
                                <div class="unify" :class="{curr:agreement == 2}" @click="onAgreement(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="agreement!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="agreement==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>部分签订</p>
                                </div>
                                <div class="unify" :class="{curr:agreement == 3}" @click="onAgreement(3)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="agreement!=3" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="agreement==3" :src="$config.resource + 'xz.png'" alt="">
                                    <p>均未签订</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">人员离岗离职安全管理规定：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:dimission == 1}" @click="onDimission(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="dimission!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="dimission==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已制定</p>
                                </div>
                                <div class="unify" :class="{curr:dimission == 2}" @click="onDimission(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="dimission!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="dimission==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未制定</p>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        <p>资</p>
                        <div class="flex-1"></div>
                        <p>产</p>
                        <div class="flex-1"></div>
                        <p>管</p>
                        <div class="flex-1"></div>
                        <p>理:</p>
                    </dt>
                    <dd>
                        <div class="row_box">
                            <div class="tt">信息安全设备运维管理：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:facility == 1}" @click="onFacility(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="facility!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="facility==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已明确专人负责</p>
                                </div>
                                <div class="unify" :class="{curr:facility == 2}" @click="onFacility(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="facility!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="facility==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未明确</p>
                                </div>
                                <div class="unify" :class="{curr:facility == 3}" @click="onFacility(3)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="facility!=3" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="facility==3" :src="$config.resource + 'xz.png'" alt="">
                                    <p>定期进行配置检查、日志审计等</p>
                                </div>
                                <div class="unify unify_OPS" :class="{curr:facility == 4}" @click="onFacility(4)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="facility!=4" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="facility==4" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未进行</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">设备维修维护和报废销毁管理：</div>
                            <div class="row">
                                <div class="unify scrap" :class="{curr:destroy == 1}" @click="onDestroy(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="destroy!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="destroy==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已建立管理制度，且维修维护和报废销毁记录完整</p>
                                </div>
                                <div class="unify scrap" :class="{curr:destroy == 2}" @click="onDestroy(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="destroy!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="destroy==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已建立管理制度，且维修维护和报废销毁记录不完整</p>
                                </div>
                                <div class="unify" :class="{curr:destroy == 3}" @click="onDestroy(3)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="destroy!=3" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="destroy==3" :src="$config.resource + 'xz.png'" alt="">
                                    <p>尚未建立管理制度</p>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
            <!-- 信息安全防护管理情况 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>信息安全防护管理情况</p>
                </div>
                <dl>
                    <dt>网络边界防护管理：</dt>
                    <dd>
                        <div class="row_box">
                            <div class="tt">网络区域划分是否合理：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:area == 1}" @click="onArea(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="area!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="area==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>合理</p>
                                </div>
                                <div class="unify" :class="{curr:area == 2}" @click="onArea(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="area!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="area==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>不合理</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">安全防护设备策略：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:tactics == 1}" @click="onTactics(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="tactics!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="tactics==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>使用默认配置</p>
                                </div>
                                <div class="unify" :class="{curr:tactics == 2}" @click="onTactics(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="tactics!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="tactics==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>根据应用自主配置</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">互联网访问控制：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:control == 1}" @click="onControl(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="control!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="control==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>有访问控制措施</p>
                                </div>
                                <div class="unify" :class="{curr:control == 2}" @click="onControl(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="control!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="control==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>无访问控制措施</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">互联网访问日志：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:log == 1}" @click="onLog(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="log!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="log==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>留存日志</p>
                                </div>
                                <div class="unify" :class="{curr:log == 2}" @click="onLog(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="log!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="log==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未留存日志</p>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>门户网站应用管理：</dt>
                    <dd>
                        <div class="row_box">
                            <div class="tt">网站</div>
                            <div class="inp_wrap">
                                <div class="name_inp">
                                    <div class="name">域名：</div>
                                    <div class="inp_box">
                                        <input class="inp" type="text" name="" id="" v-model="org" />
                                    </div>
                                </div>
                                <div class="name_inp">
                                    <div class="name">IP地址：</div>
                                    <div class="inp_box">
                                        <input class="inp" type="text" name="" id="" v-model="address" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">网站是否备案：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:file == 1}" @click="onFile(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="file!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="file==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>是</p>
                                </div>
                                <div class="unify" :class="{curr:file == 2}" @click="onFile(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="file!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="file==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>否</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">门户网站账户安全管理：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:account == 1}" @click="onAccount(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="account!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="account==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已清理无关账户</p>
                                </div>
                                <div class="unify" :class="{curr:account == 2}" @click="onAccount(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="account!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="account==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未清理</p>
                                </div>
                                <div class="unify" :class="{curr:account == 3}" @click="onAccount(3)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="account!=3" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="account==3" :src="$config.resource + 'xz.png'" alt="">
                                    <p>无，空口令、弱口令和默认口令</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">清理网站临时文件、关闭网站目录遍历功能等清理：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:clear == 1}" @click="onClear(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="clear!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="clear==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已清理</p>
                                </div>
                                <div class="unify" :class="{curr:clear == 2}" @click="onClear(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="clear!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="clear==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未清理</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">门户网站信息发布管理：</div>
                            <div class="row">
                                <div class="unify portal" :class="{curr:issue == 1}" @click="onIssue(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="issue!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="issue==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已建立审核制度，且审核记录完整</p>
                                </div>
                                <div class="unify portal" :class="{curr:issue == 2}" @click="onIssue(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="issue!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="issue==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已建立审核制度，但审核记录不完整</p>
                                </div>
                                <div class="unify" :class="{curr:issue == 3}" @click="onIssue(3)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="issue!=3" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="issue==3" :src="$config.resource + 'xz.png'" alt="">
                                    <p>尚未建立审核制度</p>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>存储设备安全管理：</dt>
                    <dd>
                        <div class="row_box">
                            <div class="tt">移动储蓄设备管理方式：</div>
                            <div class="row">
                                <div class="unify allocate" :class="{curr:savings == 1}" @click="onSavings(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="savings!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="savings==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>集中管理，同意登记、配发、回收、维修、报废、销毁</p>
                                </div>
                                <div class="unify" :class="{curr:savings == 2}" @click="onSavings(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="savings!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="savings==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未采取集中管理相关措施</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">在非涉密信息系统和涉密信息系统间混用情况：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:blended == 1}" @click="onBlended(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="blended!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="blended==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>不存在</p>
                                </div>
                                <div class="unify" :class="{curr:blended == 2}" @click="onBlended(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="blended!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="blended==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>存在</p>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>信息系统安全管理：</dt>
                    <dd>
                        <div class="row_box">
                            <div class="tt">服务器安全防护：</div>
                            <div class="tt">不必要的应用、服务、端口:</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:serve == 1}" @click="onServe(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="serve!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="serve==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>关闭</p>
                                </div>
                                <div class="unify" :class="{curr:serve == 2}" @click="onServe(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="serve!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="serve==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未关闭</p>
                                </div>
                            </div>
                            <div class="tt">账户口令设置8位，包含数字、字母或符号:</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:set_one == 1}" @click="onSet_one(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="set_one!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="set_one==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>满足</p>
                                </div>
                                <div class="unify" :class="{curr:set_one == 2}" @click="onSet_one(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="set_one!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="set_one==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>不满足</p>
                                </div>
                            </div>
                            <div class="tt">扫描、病毒木马监测:</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:scan_one == 1}" @click="onScan_one(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="scan_one!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="scan_one==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>定期进行</p>
                                </div>
                                <div class="unify" :class="{curr:scan_one == 2}" @click="onScan_one(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="scan_one!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="scan_one==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未进行</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">网络设备防护：</div>
                            <div class="tt">安全策略配置:</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:defend == 1}" @click="onDefend(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="defend!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="defend==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>有效</p>
                                </div>
                                <div class="unify" :class="{curr:defend == 2}" @click="onDefend(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="defend!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="defend==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>无效</p>
                                </div>
                            </div>
                            <div class="tt">账户口令设置8位，包含数字、字母或符号:</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:set_two == 1}" @click="onSet_two(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="set_two!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="set_two==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>满足</p>
                                </div>
                                <div class="unify" :class="{curr:set_two == 2}" @click="onSet_two(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="set_two!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="set_two==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>不满足</p>
                                </div>
                            </div>
                            <div class="tt">扫描、病毒木马监测:</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:scan_two == 1}" @click="onScan_two(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="scan_two!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="scan_two==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>定期进行</p>
                                </div>
                                <div class="unify" :class="{curr:scan_two == 2}" @click="onScan_two(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="scan_two!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="scan_two==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未进行</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">信息安全设备部署及使用：</div>
                            <div class="tt">防病毒、防火墙、入侵检测、安全审计等功能的设备:</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:deploy == 1}" @click="onDeploy(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="deploy!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="deploy==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>已部署</p>
                                </div>
                                <div class="unify" :class="{curr:deploy == 2}" @click="onDeploy(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="deploy!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="deploy==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未部署</p>
                                </div>
                                
                            </div>
                            <div class="tt">安全策略配置:</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:deploy_two == 1}" @click="onDeploy_two(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="deploy_two!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="deploy_two==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>有效</p>
                                </div>
                                <div class="unify" :class="{curr:deploy_two == 2}" @click="onDeploy_two(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="deploy_two!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="deploy_two==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>无效</p>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>终端计算机安全管理：</dt>
                    <dd>
                        <div class="row_box">
                            <div class="tt">终端计算机安全管理方式：</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:way == 1}" @click="onWay(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="way!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="way==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>使用同意平台对终端计算机进行集中管理</p>
                                </div>
                                <div class="unify" :class="{curr:way == 2}" @click="onWay(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="way!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="way==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>用户分散管理</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">账户口令管理：</div>
                            <div class="row fence">
                                <div class="unify" :class="{curr:word == 1}" @click="onWord(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="word!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="word==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>无，空口令、弱口令和默认口令</p>
                                </div>
                                <div class="unify" :class="{curr:word == 2}" @click="onWord(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="word!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="word==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>有</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">接入互联网安全控制措施：</div>
                            <div class="row">
                                <div class="unify internet" :class="{curr:measure == 1}" @click="onMeasure(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="measure!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="measure==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>有控制措施（如实名接入、绑定计算机IP和MAC地址等）</p>
                                </div>
                                <div class="unify" :class="{curr:measure == 2}" @click="onMeasure(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="measure!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="measure==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>无控制措施</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">在非涉密信息系统和涉密信息系统混合使用情况：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:mingle == 1}" @click="onMingle(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="mingle!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="mingle==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>不存在</p>
                                </div>
                                <div class="unify" :class="{curr:mingle == 2}" @click="onMingle(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="mingle!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="mingle==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>存在</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">漏洞扫描木马检测：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:scan == 1}" @click="onScan(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="scan!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="scan==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>定期进行</p>
                                </div>
                                <div class="unify" :class="{curr:scan == 2}" @click="onScan(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="scan!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="scan==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未进行</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">是否存在使用非涉密计算计算机处理涉密信息情况：</div>
                            <div class="row">
                                <div class="unify" :class="{curr:existIndex == 1}" @click="onExist(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="existIndex!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="existIndex==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>不存在</p>
                                </div>
                                <div class="unify" :class="{curr:existIndex == 2}" @click="onExist(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="existIndex!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="existIndex==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>存在，请描述事件：</p>
                                    <div class="relation">
                                        <input v-if="existIndex==2" class="inp" type="text" v-model="exist" ref="exist_one" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
            <!-- 信息安全应急管理情况 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>信息安全应急管理情况</p>
                </div>
                <div class="parallel">
                    <div class="tt">应急预案制定及备案情况：</div>
                    <div class="row">
                        <div class="unify" :class="{curr:enact == 1}" @click="onEnact(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="enact!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="enact==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>已备案</p>
                        </div>
                        <div class="unify" :class="{curr:enact == 2}" @click="onEnact(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="enact!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="enact==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>已制定但未备案</p>
                        </div>
                        <div class="unify" :class="{curr:enact == 3}" @click="onEnact(3)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="enact!=3" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="enact==3" :src="$config.resource + 'xz.png'" alt="">
                            <p>未制定</p>
                        </div>
                    </div>
                </div>
                <div class="parallel">
                    <div class="tt">应急技术支援队伍：</div>
                    <div class="row">
                        <div class="unify" :class="{curr:skill == 1}" @click="onSkill(1)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="skill!=1" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="skill==1" :src="$config.resource + 'xz.png'" alt="">
                            <p>本单位自身力量</p>
                        </div>
                        <div class="unify" :class="{curr:skill == 2}" @click="onSkill(2)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="skill!=2" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="skill==2" :src="$config.resource + 'xz.png'" alt="">
                            <p>外部专业机构</p>
                        </div>
                        <div class="unify" :class="{curr:skill == 3}" @click="onSkill(3)">
                            <!-- 未选中 -->
                            <img class="icon" v-if="skill!=3" :src="$config.resource + 'wxz.png'" alt="">
                            <!-- 已选中 -->
                            <img class="icon" v-if="skill==3" :src="$config.resource + 'xz.png'" alt="">
                            <p>未明确</p>
                        </div>
                    </div>
                </div>
                <dl class="backups">
                    <dt>
                        <p>信</p>
                        <div class="flex-1"></div>
                        <p>息</p>
                        <div class="flex-1"></div>
                        <p>安</p>
                        <div class="flex-1"></div>
                        <p>全</p>
                        <div class="flex-1"></div>
                        <p>备</p>
                        <div class="flex-1"></div>
                        <p>份:</p>
                        <div class="flex-1"></div>
                    </dt>
                    <dd>
                        <div class="row_box">
                            <div class="tt">重要数据</div>
                            <div class="row">
                                <div class="unify" :class="{curr:wd == 1}" @click="onWd(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="wd!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="wd==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>备份</p>
                                </div>
                                <div class="unify" :class="{curr:wd == 2}" @click="onWd(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="wd!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="wd==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未备份</p>
                                </div>
                            </div>
                        </div>
                        <div class="row_box">
                            <div class="tt">重要信息系统</div>
                            <div class="row">
                                <div class="unify" :class="{curr:lineage == 1}" @click="onLineage(1)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="lineage!=1" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="lineage==1" :src="$config.resource + 'xz.png'" alt="">
                                    <p>备份</p>
                                </div>
                                <div class="unify" :class="{curr:lineage == 2}" @click="onLineage(2)">
                                    <!-- 未选中 -->
                                    <img class="icon" v-if="lineage!=2" :src="$config.resource + 'wxz.png'" alt="">
                                    <!-- 已选中 -->
                                    <img class="icon" v-if="lineage==2" :src="$config.resource + 'xz.png'" alt="">
                                    <p>未备份</p>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
            <!-- 信息安全教育培训情况 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>信息安全教育培训情况</p>
                </div>
                <div class="train_box">
                    <div class="attend_box">
                        <div class="name">参加培训情况：</div>
                        <div class="select_box">
                            <div class="unify" :class="{curr:trainIndex == 1}" @click="onTrain(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="trainIndex!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="trainIndex==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>本年度是否派员参加信息安全相关业务培训，人/次数：</p>
                                <div class="relation">
                                    <input v-if="trainIndex==1" class="inp" type="text" v-model="attend" ref="attend" />
                                </div>
                                <p>培训部门名称：</p>
                                <div class="relation_two">
                                    <input v-if="trainIndex==1" class="inp" type="text" v-model="branch" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="attend_box">
                        <div class="name">组织培训情况：</div>
                        <div class="select_box">
                            <div class="unify" :class="{curr:tissueIndex == 1}" @click="onTissue(1)">
                                <!-- 未选中 -->
                                <img class="icon" v-if="tissueIndex!=1" :src="$config.resource + 'wxz.png'" alt="">
                                <!-- 已选中 -->
                                <img class="icon" v-if="tissueIndex==1" :src="$config.resource + 'xz.png'" alt="">
                                <p>本年度是否组织展开信息安全教育培训，次数：</p>
                                <div class="organization">
                                    <input v-if="tissueIndex==1" class="inp" type="text" v-model="tissue" ref="tissue" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row row_two">
                        <div class="tt">参训人员比例：</div>
                        <div class="name_inp">
                            <div class="name name_two">本年度参加信息安全教育培训的人员占总人数比例为：</div>
                            <div class="inp_box">
                                <input class="inp" type="text" name="" id="" v-model="ratio" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 本年度信息安全事件情况 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>本年度信息安全事件情况</p>
                </div>
                <div class="COUNT">
                    <div class="name">本年度安全事件统计：</div>
                    <div class="COUNT_box">
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">进行过病毒木马等恶意代码检查服务器的台数：</div>
                                <div class="inp_box inp_first">
                                    <input class="inp" type="number" name="" id="" v-model="virus" />
                                </div>
                            </div>
                            <div class="right_box">
                                <div class="tt">其中感染恶意代码的服务器台数：</div>
                                <div class="inp_box inp_first">
                                    <input class="inp" type="number" name="" id="" v-model="infection" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">进行过病毒木马等恶意代码检测的终端计算机台数：</div>
                                <div class="inp_box">
                                    <input class="inp" type="number" name="" id="" v-model="viciousness" />
                                </div>
                            </div>
                            <div class="right_box">
                                <div class="tt">其中感染恶意代码的终端计算机台数：</div>
                                <div class="inp_box">
                                    <input class="inp" type="number" name="" id="" v-model="venom" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">进行过漏洞扫描的服务器台数：</div>
                                <div class="inp_box inp_second">
                                    <input class="inp" type="number" name="" id="" v-model="flaw " />
                                </div>
                            </div>
                            <div class="right_box">
                                <div class="tt">其中存在漏洞的服务器台数：</div>
                                <div class="inp_box inp_second">
                                    <input class="inp" type="number" name="" id="" v-model="loophole" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">其中存在高风险漏洞的服务器台数：</div>
                                <div class="inp_box inp_third">
                                    <input class="inp" type="number" name="" id="" v-model="defect" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">进行过漏洞扫描的终端计算机台数：</div>
                                <div class="inp_box inp_third">
                                    <input class="inp" type="number" name="" id="" v-model="leak" />
                                </div>
                            </div>
                            <div class="right_box">
                                <div class="tt">其中存在漏洞的终端计算器台数：</div>
                                <div class="inp_box inp_first">
                                    <input class="inp" type="number" name="" id="" v-model="hole" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">其中存在高风险漏洞的终端计算器台数：</div>
                                <div class="inp_box inp_fourth">
                                    <input class="inp" type="number" name="" id="" v-model="high_risk" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">门户网站网页被篡改（内含嵌恶意代码）次数：</div>
                                <div class="inp_box inp_first">
                                    <input class="inp" type="number" name="" id="" v-model="spite" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">使用非涉密终端计算机处理涉密信息事件数：</div>
                                <div class="inp_box">
                                    <input class="inp" type="number" name="" id="" v-model="use" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="left_box">
                                <div class="tt">终端计算机在非涉密系统和涉密系统间混用事件数：</div>
                                <div class="inp_box">
                                    <input class="inp" type="number" name="" id="" v-model="system" />
                                </div>
                            </div>
                        </div>
                        <div class="equal">
                            <div class="finally">
                                <div class="tt">移动存储介质在非涉密系统和涉密系统间交叉使用事件数：</div>
                                <div class="inp_box">
                                    <input class="inp" type="number" name="" id="" v-model="shift" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 信息安全管理体系认证情况 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>信息安全管理体系认证情况</p>
                </div>
                <div class="system">
                    <div class="unify" :class="{curr:attestationIndex == 1}" @click="onAttestation(1)">
                        <!-- 未选中 -->
                        <img class="icon" v-if="attestationIndex!=1" :src="$config.resource + 'wxz.png'" alt="">
                        <!-- 已选中 -->
                        <img class="icon" v-if="attestationIndex==1" :src="$config.resource + 'xz.png'" alt="">
                        <p>已通过认证，认证机构：</p>
                        <div class="relation">
                            <input v-if="attestationIndex==1" class="inp" type="text" v-model="attestation" ref="attestation" />
                        </div>
                    </div>
                    <div class="unify" :class="{curr:attestationIndex == 2}" @click="onAttestation(2)">
                        <!-- 未选中 -->
                        <img class="icon" v-if="attestationIndex!=2" :src="$config.resource + 'wxz.png'" alt="">
                        <!-- 已选中 -->
                        <img class="icon" v-if="attestationIndex==2" :src="$config.resource + 'xz.png'" alt="">
                        <p>未认证</p>
                    </div>
                </div>
            </div>
            <!-- 按钮 -->
            <div class="btn_box">
                <div class="btn gray" @click="onDown">下载信息安全调查表</div>
                <div class="btn gray" v-if="isType!=2">
                    <em>上传信息安全调查表</em>
                    <input 
                        class="uploadBtn" 
                        name="key" 
                        type="file" 
                        @change="uploadFile($event)" 
                        ref="inputer" 
                        accept=".pdf" 
                    />
                </div>
                <div class="btn gray" v-if="isType!=2" @click="onSave">保存草稿</div>
                <div class="btn gray" @click="onBack">上一步</div>
                <div class="btn red" v-if="isType!=2" @click="onSubmit">下一步</div>
                <div class="btn red" v-if="isType==2" @click="toViewPage('/accessory',{type:2})">下一步</div>
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                user:'',// 用户信息
                isType:'',// 1.提交下一步 2.详情下一步 3.重新提交

                duty:'',// 岗位信息安全和保密责任制度
                agreement:'',// 重要岗位人员信息安全和保密协议
                dimission:'',// 人员离岗离职安全管理规定
                facility:'',// 信息安全设备运维管理
                destroy:'',// 设备维修维护和报废销毁管理

                area:'',// 网络区域划分是否合理
                tactics:'',// 安全防护设备策略
                control:'',// 互联网访问控制
                log:'',// 互联网访问日志
                org:'',// 域名
                address:'',// IP地址
                file:'',// 网站是否备案
                account:'',// 门户网站账户安全管理
                clear:'',// 清理网站临时文件、关闭网站目录遍历功能等清理
                issue:'',// 门户网站信息发布管理
                savings:'',// 移动储蓄设备管理方式
                blended:'',// 在非涉密信息系统和涉密信息系统间混用情况
                serve:'',// 服务器安全防护:不必要的应用、服务、端口
                set_one:'',// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                scan_one:'',// 服务器安全防护:扫描、病毒木马监测
                defend:'',// 网络设备防护:安全策略配置
                set_two:'',// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                scan_two:'',// 网络设备防护:扫描、病毒木马监测
                deploy:'',// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                deploy_two:'',// 信息安全设备部署及使用:安全策略配置
                way:'',// 终端计算机安全管理方式
                word:'',// 账户口令管理
                measure:'',// 接入互联网安全控制措施
                mingle:'',// 在非涉密信息系统和涉密信息系统混合使用情况
                scan:'',// 漏洞扫描木马检测
                existIndex:'',// 是否存在使用非涉密计算计算机处理涉密信息情况
                exist:'',// 是否存在使用非涉密计算计算机处理涉密信息情况输入框
                
                enact:'',// 应急预案制定及备案情况
                skill:'',// 应急技术支援队伍
                wd:'',// 重要数据
                lineage:'',// 重要信息系统

                trainIndex:0,// 参加培训情况
                attend:'',// 本年度是否派员参加信息安全相关业务培训，人/次数
                branch:'',// 培训部门名称
                tissueIndex:0,// 组织培训情况
                tissue:'',// 本年度是否组织展开信息安全教育培训，人/次数
                ratio:'',// 参训人员比例

                virus:'',// 进行过病毒木马等恶意代码检查服务器的台数
                infection:'',// 其中感染恶意代码的服务器台数
                viciousness:'',// 进行过病毒木马等恶意代码检测的终端计算机台数
                venom:'',// 其中感染恶意代码的终端计算机台数
                flaw:'',// 进行过漏洞扫描的服务器台数
                loophole:'',// 其中存在漏洞的服务器台数
                defect:'',// 其中存在高风险漏洞的服务器台数
                leak:'',// 进行过漏洞扫描的终端计算机台数
                hole:'',// 其中存在漏洞的终端计算器台数
                high_risk:'',// 其中存在高风险漏洞的终端计算器台数
                spite:'',// 门户网站网页被篡改（内含嵌恶意代码）次数
                use:'',// 使用非涉密终端计算机处理涉密信息事件数
                system:'',// 终端计算器在非涉密系统和涉密系统间混用事件数
                shift:'',// 移动存储介质在非涉密系统和涉密系统间交叉使用事件数

                attestationIndex:'',// 信息安全管理体系认证情况
                attestation:'',// 信息安全管理体系认证情况输入框
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 下载知识产权调查表
            onDown(){
                const that = this
                let start_train = '';// 组织培训情况
                if(that.tissueIndex ==1){
                    start_train = that.tissue
                }else{
                    start_train = that.tissueIndex
                }
                let classified = '';// 是否存在使用非涉密计算计算机处理涉密信息情况
                if(that.existIndex ==2){
                    classified = exist
                }else{
                    classified = 0
                }
                let is_pass = '';// 信息安全管理体系认证情况
                if(that.attestationIndex ==2){
                    is_pass = 0
                }else{
                    is_pass = that.attestation
                }
                that.$request({
                    that: that,
                    api: that.$api.safetyDown,
                    loading: true,
                    data: {
                        is_system:that.duty,// 岗位信息安全和保密责任制度
                        is_nda:that.agreement,// 重要岗位人员信息安全和保密协议
                        is_safety:that.dimission,// 人员离岗离职安全管理规定
                        safety_manage:that.facility,// 信息安全设备运维管理
                        plant_manage:that.destroy,// 设备维修维护和报废销毁管理

                        areas:that.area,// 网络区域划分是否合理
                        safety_eq:that.tactics,// 安全防护设备策略
                        access:that.control,// 互联网访问控制
                        is_log:that.log,// 互联网访问日志
                        domain:that.org,// 域名
                        ip:that.address,// IP地址
                        web_record:that.file,// 网站是否备案
                        account:that.account,// 门户网站账户安全管理
                        clear:that.clear,// 清理网站临时文件、关闭网站目录遍历功能等清理
                        website:that.issue,// 门户网站信息发布管理
                        memory:that.savings,// 移动储蓄设备管理方式
                        system_mix:that.blended,// 在非涉密信息系统和涉密信息系统间混用情况
                        server_protection:that.serve,// 服务器安全防护:不必要的应用、服务、端口
                        server_account:that.set_one,// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                        server_scan:that.scan_one,// 服务器安全防护:扫描、病毒木马监测
                        network_protection:that.defend,// 网络设备防护:安全策略配置
                        network_account:that.set_two,// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                        network_scan:that.scan_two,// 网络设备防护:扫描、病毒木马监测
                        safety:that.deploy,// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                        policy:that.deploy_two,// 信息安全设备部署及使用:安全策略配置
                        computer:that.way,// 终端计算机安全管理方式
                        account_token:that.word,// 账户口令管理
                        net_safe:that.measure,// 接入互联网安全控制措施
                        mixing:that.mingle,// 在非涉密信息系统和涉密信息系统混合使用情况
                        scanning:that.scan,// 漏洞扫描木马检测
                        classified:classified,// 是否存在使用非涉密计算计算机处理涉密信息情况

                        plan_record:that.enact,// 应急预案制定及备案情况
                        support_team:that.skill,// 应急技术支援队伍
                        backup_data:that.wd,// 重要数据
                        backup_sys:that.lineage,// 重要信息系统

                        is_train:that.tissueIndex,// 参加培训情况
                        people:that.attend,// 本年度是否派员参加信息安全相关业务培训，人/次数
                        train_name:that.branch,// 培训部门名称
                        start_train:start_train,// 组织培训情况
                        ratio:that.ratio,// 参训人员比例

                        virusfree_servers:that.virus,// 进行过病毒木马等恶意代码检查服务器的台数
                        virus_servers:that.infection,// 其中感染恶意代码的服务器台数
                        virusfree_computer:that.viciousness,// 进行过病毒木马等恶意代码检测的终端计算机台数
                        virus_computer:that.venom,// 其中感染恶意代码的终端计算机台数
                        scanned_servers:that.flaw,// 进行过漏洞扫描的服务器台数
                        vulnerable_servers:that.loophole,// 其中存在漏洞的服务器台数
                        highrisk_servers:that.defect,// 其中存在高风险漏洞的服务器台数
                        scanned_computer:that.leak,// 进行过漏洞扫描的终端计算机台数
                        vulnerable_computer:that.hole,// 其中存在漏洞的终端计算器台数
                        highrisk_computer:that.high_risk,// 其中存在高风险漏洞的终端计算器台数
                        tamper_number:that.spite,// 门户网站网页被篡改（内含嵌恶意代码）次数
                        process_number:that.use,// 使用非涉密终端计算机处理涉密信息事件数
                        mixed_number:that.system,// 终端计算器在非涉密系统和涉密系统间混用事件数
                        storage_mixed:that.shift,// 移动存储介质在非涉密系统和涉密系统间交叉使用事件数

                        is_pass:is_pass,// 信息安全管理体系认证情况
                    },
                    success(res) {
                       window.open(res.data.inquiry)
                    }
                })
            },
            // 上传知识产权调查表
            onPut(){},
            // 保存草稿
            onSave(){
                const that = this
                let start_train = '';// 组织培训情况
                if(that.tissueIndex ==1){
                    start_train = that.tissue
                }else{
                    start_train = that.tissueIndex
                }
                let classified = '';// 是否存在使用非涉密计算计算机处理涉密信息情况
                if(that.existIndex ==2){
                    classified = exist
                }else{
                    classified = 0
                }
                let is_pass = '';// 信息安全管理体系认证情况
                if(that.attestationIndex ==2){
                    is_pass = 0
                }else{
                    is_pass = that.attestation
                }
                that.$request({
                    that: that,
                    api: that.$api.safety,
                    data: {
                        is_system:that.duty,// 岗位信息安全和保密责任制度
                        is_nda:that.agreement,// 重要岗位人员信息安全和保密协议
                        is_safety:that.dimission,// 人员离岗离职安全管理规定
                        safety_manage:that.facility,// 信息安全设备运维管理
                        plant_manage:that.destroy,// 设备维修维护和报废销毁管理

                        areas:that.area,// 网络区域划分是否合理
                        safety_eq:that.tactics,// 安全防护设备策略
                        access:that.control,// 互联网访问控制
                        is_log:that.log,// 互联网访问日志
                        domain:that.org,// 域名
                        ip:that.address,// IP地址
                        web_record:that.file,// 网站是否备案
                        account:that.account,// 门户网站账户安全管理
                        clear:that.clear,// 清理网站临时文件、关闭网站目录遍历功能等清理
                        website:that.issue,// 门户网站信息发布管理
                        memory:that.savings,// 移动储蓄设备管理方式
                        system_mix:that.blended,// 在非涉密信息系统和涉密信息系统间混用情况
                        server_protection:that.serve,// 服务器安全防护:不必要的应用、服务、端口
                        server_account:that.set_one,// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                        server_scan:that.scan_one,// 服务器安全防护:扫描、病毒木马监测
                        network_protection:that.defend,// 网络设备防护:安全策略配置
                        network_account:that.set_two,// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                        network_scan:that.scan_two,// 网络设备防护:扫描、病毒木马监测
                        safety:that.deploy,// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                        policy:that.deploy_two,// 信息安全设备部署及使用:安全策略配置
                        computer:that.way,// 终端计算机安全管理方式
                        account_token:that.word,// 账户口令管理
                        net_safe:that.measure,// 接入互联网安全控制措施
                        mixing:that.mingle,// 在非涉密信息系统和涉密信息系统混合使用情况
                        scanning:that.scan,// 漏洞扫描木马检测
                        classified:classified,// 是否存在使用非涉密计算计算机处理涉密信息情况

                        plan_record:that.enact,// 应急预案制定及备案情况
                        support_team:that.skill,// 应急技术支援队伍
                        backup_data:that.wd,// 重要数据
                        backup_sys:that.lineage,// 重要信息系统

                        is_train:that.tissueIndex,// 参加培训情况
                        people:that.attend,// 本年度是否派员参加信息安全相关业务培训，人/次数
                        train_name:that.branch,// 培训部门名称
                        start_train:start_train,// 组织培训情况
                        ratio:that.ratio,// 参训人员比例

                        virusfree_servers:that.virus,// 进行过病毒木马等恶意代码检查服务器的台数
                        virus_servers:that.infection,// 其中感染恶意代码的服务器台数
                        virusfree_computer:that.viciousness,// 进行过病毒木马等恶意代码检测的终端计算机台数
                        virus_computer:that.venom,// 其中感染恶意代码的终端计算机台数
                        scanned_servers:that.flaw,// 进行过漏洞扫描的服务器台数
                        vulnerable_servers:that.loophole,// 其中存在漏洞的服务器台数
                        highrisk_servers:that.defect,// 其中存在高风险漏洞的服务器台数
                        scanned_computer:that.leak,// 进行过漏洞扫描的终端计算机台数
                        vulnerable_computer:that.hole,// 其中存在漏洞的终端计算器台数
                        highrisk_computer:that.high_risk,// 其中存在高风险漏洞的终端计算器台数
                        tamper_number:that.spite,// 门户网站网页被篡改（内含嵌恶意代码）次数
                        process_number:that.use,// 使用非涉密终端计算机处理涉密信息事件数
                        mixed_number:that.system,// 终端计算器在非涉密系统和涉密系统间混用事件数
                        storage_mixed:that.shift,// 移动存储介质在非涉密系统和涉密系统间交叉使用事件数

                        is_pass:is_pass,// 信息安全管理体系认证情况
                        type:2,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                        })
                    }
                })
            },
            // 上一步
            onBack(){
                this.$router.go(-1);
            },
            // 提交下一步
            onSubmit(){
                const that = this
                let start_train = '';// 组织培训情况
                if(that.tissueIndex ==1){
                    start_train = that.tissue
                }else{
                    start_train = that.tissueIndex
                }
                let classified = '';// 是否存在使用非涉密计算计算机处理涉密信息情况
                if(that.existIndex ==2){
                    classified = that.exist
                }else{
                    classified = 0
                }
                let is_pass = '';// 信息安全管理体系认证情况
                if(that.attestationIndex ==2){
                    is_pass = 0
                }else{
                    is_pass = that.attestation
                }
                that.$request({
                    that: that,
                    api: that.$api.safety,
                    data: {
                        is_system:that.duty,// 岗位信息安全和保密责任制度
                        is_nda:that.agreement,// 重要岗位人员信息安全和保密协议
                        is_safety:that.dimission,// 人员离岗离职安全管理规定
                        safety_manage:that.facility,// 信息安全设备运维管理
                        plant_manage:that.destroy,// 设备维修维护和报废销毁管理

                        areas:that.area,// 网络区域划分是否合理
                        safety_eq:that.tactics,// 安全防护设备策略
                        access:that.control,// 互联网访问控制
                        is_log:that.log,// 互联网访问日志
                        domain:that.org,// 域名
                        ip:that.address,// IP地址
                        web_record:that.file,// 网站是否备案
                        account:that.account,// 门户网站账户安全管理
                        clear:that.clear,// 清理网站临时文件、关闭网站目录遍历功能等清理
                        website:that.issue,// 门户网站信息发布管理
                        memory:that.savings,// 移动储蓄设备管理方式
                        system_mix:that.blended,// 在非涉密信息系统和涉密信息系统间混用情况
                        server_protection:that.serve,// 服务器安全防护:不必要的应用、服务、端口
                        server_account:that.set_one,// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                        server_scan:that.scan_one,// 服务器安全防护:扫描、病毒木马监测
                        network_protection:that.defend,// 网络设备防护:安全策略配置
                        network_account:that.set_two,// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                        network_scan:that.scan_two,// 网络设备防护:扫描、病毒木马监测
                        safety:that.deploy,// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                        policy:that.deploy_two,// 信息安全设备部署及使用:安全策略配置
                        computer:that.way,// 终端计算机安全管理方式
                        account_token:that.word,// 账户口令管理
                        net_safe:that.measure,// 接入互联网安全控制措施
                        mixing:that.mingle,// 在非涉密信息系统和涉密信息系统混合使用情况
                        scanning:that.scan,// 漏洞扫描木马检测
                        classified:classified,// 是否存在使用非涉密计算计算机处理涉密信息情况

                        plan_record:that.enact,// 应急预案制定及备案情况
                        support_team:that.skill,// 应急技术支援队伍
                        backup_data:that.wd,// 重要数据
                        backup_sys:that.lineage,// 重要信息系统

                        is_train:that.tissueIndex,// 参加培训情况
                        people:that.attend,// 本年度是否派员参加信息安全相关业务培训，人/次数
                        train_name:that.branch,// 培训部门名称
                        start_train:start_train,// 组织培训情况
                        ratio:that.ratio,// 参训人员比例

                        virusfree_servers:that.virus,// 进行过病毒木马等恶意代码检查服务器的台数
                        virus_servers:that.infection,// 其中感染恶意代码的服务器台数
                        virusfree_computer:that.viciousness,// 进行过病毒木马等恶意代码检测的终端计算机台数
                        virus_computer:that.venom,// 其中感染恶意代码的终端计算机台数
                        scanned_servers:that.flaw,// 进行过漏洞扫描的服务器台数
                        vulnerable_servers:that.loophole,// 其中存在漏洞的服务器台数
                        highrisk_servers:that.defect,// 其中存在高风险漏洞的服务器台数
                        scanned_computer:that.leak,// 进行过漏洞扫描的终端计算机台数
                        vulnerable_computer:that.hole,// 其中存在漏洞的终端计算器台数
                        highrisk_computer:that.high_risk,// 其中存在高风险漏洞的终端计算器台数
                        tamper_number:that.spite,// 门户网站网页被篡改（内含嵌恶意代码）次数
                        process_number:that.use,// 使用非涉密终端计算机处理涉密信息事件数
                        mixed_number:that.system,// 终端计算器在非涉密系统和涉密系统间混用事件数
                        storage_mixed:that.shift,// 移动存储介质在非涉密系统和涉密系统间交叉使用事件数

                        is_pass:is_pass,// 信息安全管理体系认证情况
                        type:1,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                            callback(){
                                that.$router.push({ path: '/accessory',query:{type:that.isType} })
                            }
                        })
                    }
                })
            },
            // 岗位信息安全和保密责任制度
            onDuty(duty){
                this.duty = duty
            },
            // 重要岗位人员信息安全和保密协议
            onAgreement(agreement){
                this.agreement = agreement
            },
            // 人员离岗离职安全管理规定
            onDimission(dimission){
                this.dimission = dimission
            },
            // 信息安全设备运维管理
            onFacility(facility){
                this.facility = facility
            },
            // 设备维修维护和报废销毁管理
            onDestroy(destroy){
                this.destroy = destroy
            },
            // 网络区域划分是否合理
            onArea(area){
                this.area = area
            },
            // 安全防护设备策略
            onTactics(tactics){
                this.tactics = tactics
            },
            // 互联网访问控制
            onControl(control){
                this.control = control
            },
            // 互联网访问日志
            onLog(log){
                this.log = log
            },
            // 网站是否备案
            onFile(file){
                this.file = file
            },
            // 门户网站账户安全管理
            onAccount(account){
                this.account = account
            },
            // 清理网站临时文件、关闭网站目录遍历功能等清理
            onClear(clear){
                this.clear = clear
            },
            // 门户网站信息发布管理
            onIssue(issue){
                this.issue = issue
            },
            // 移动储蓄设备管理方式
            onSavings(savings){
                this.savings = savings
            },
            // 在非涉密信息系统和涉密信息系统间混用情况
            onBlended(blended){
                this.blended = blended
            },
            // 服务器安全防护:不必要的应用、服务、端口
            onServe(serve){
                this.serve = serve
            },
            // 服务器安全防护:账户口令设置8位，包含数字、字母或符号
            onSet_one(set_one){
                this.set_one = set_one
            },
            // 服务器安全防护:扫描、病毒木马监测
            onScan_one(scan_one){
                this.scan_one = scan_one
            },
            // 网络设备防护:安全策略配置
            onDefend(defend){
                this.defend = defend
            },
            // 网络设备防护:账户口令设置8位，包含数字、字母或符号
            onSet_two(set_two){
                this.set_two = set_two
            },
            // 网络设备防护:扫描、病毒木马监测
            onScan_two(scan_two){
                this.scan_two = scan_two
            },
            // 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
            onDeploy(deploy){
                this.deploy = deploy
            },
            // 信息安全设备部署及使用:安全策略配置
            onDeploy_two(deploy_two){
                this.deploy_two = deploy_two
            },
            // 终端计算机安全管理
            onWay(way){
                this.way = way
            },
            // 账户口令管理
            onWord(word){
                this.word = word
            },
            // 接入互联网安全控制措施
            onMeasure(measure){
                this.measure = measure
            },
            // 在非涉密信息系统和涉密信息系统混合使用情况
            onMingle(mingle){
                this.mingle = mingle
            },
            // 漏洞扫描木马检测
            onScan(scan){
                this.scan = scan
            },
            // 是否存在使用非涉密计算计算机处理涉密信息情况
            onExist(existIndex){
                this.existIndex = existIndex
                if(existIndex==2){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.exist_one.focus()
                    })
                    
                }
            },

            // 应急预案制定及备案情况
            onEnact(enact){
                this.enact = enact
            },
            // 应急技术支援队伍
            onSkill(skill){
                this.skill = skill
            },
            // 重要数据
            onWd(wd){
                this.wd = wd
            },
            // 重要信息系统
            onLineage(lineage){
                this.lineage = lineage
            },
            // 参加培训情况
            onTrain(trainIndex){
                this.trainIndex = trainIndex
            },
            // 组织培训情况
            onTissue(tissueIndex){
                this.tissueIndex = tissueIndex
                this.$nextTick((x)=>{   //正确写法
                    this.$refs.tissue.focus()
                })
            },
            // 信息安全管理体系认证情况
            onAttestation(attestationIndex){
                this.attestationIndex = attestationIndex
                if(attestationIndex==1){
                    this.$nextTick((x)=>{   //正确写法
                        this.$refs.attestation.focus()
                    })
                }
            },

            // 获取保存草稿
            getDraft(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.safetyDraft,
                    data: {},
                    success(res) {
                        if(res.data.is_system!=null&&res.data.is_system!=''){// 岗位信息安全和保密责任制度
                            that.duty = res.data.is_system 
                        }
                        if(res.data.is_nda!=null&&res.data.is_nda!=''){// 重要岗位人员信息安全和保密协议
                            that.agreement = res.data.is_nda 
                        }
                        if(res.data.is_safety!=null&&res.data.is_safety!=''){// 人员离岗离职安全管理规定
                            that.dimission = res.data.is_safety 
                        }
                        if(res.data.safety_manage!=null&&res.data.safety_manage!=''){// 信息安全设备运维管理
                            that.facility = res.data.safety_manage 
                        }
                        if(res.data.plant_manage!=null&&res.data.plant_manage!=''){// 设备维修维护和报废销毁管理
                            that.destroy = res.data.plant_manage 
                        }
                        if(res.data.areas!=null&&res.data.areas!=''){// 网络区域划分是否合理
                            that.area = res.data.areas 
                        }
                        if(res.data.safety_eq!=null&&res.data.safety_eq!=''){// 安全防护设备策略
                            that.tactics = res.data.safety_eq 
                        }
                        if(res.data.access!=null&&res.data.access!=''){// 互联网访问控制
                            that.control = res.data.access 
                        }
                        if(res.data.is_log!=null&&res.data.is_log!=''){// 互联网访问日志
                            that.log = res.data.is_log 
                        }
                        that.org = res.data.domain // 域名
                        that.address = res.data.ip // IP地址
                        if(res.data.web_record!=null&&res.data.web_record!=''){// 网站是否备案
                            that.file = res.data.web_record 
                        }
                        if(res.data.account!=null&&res.data.account!=''){// 门户网站账户安全管理
                            that.account = res.data.account 
                        }
                        if(res.data.clear!=null&&res.data.clear!=''){// 清理网站临时文件、关闭网站目录遍历功能等清理
                            that.clear = res.data.clear 
                        }
                        if(res.data.website!=null&&res.data.website!=''){// 门户网站信息发布管理
                            that.issue = res.data.website 
                        }
                        if(res.data.memory!=null&&res.data.memory!=''){// 移动储蓄设备管理方式
                            that.savings = res.data.memory 
                        }
                        if(res.data.system_mix!=null&&res.data.system_mix!=''){// 在非涉密信息系统和涉密信息系统间混用情况
                            that.blended = res.data.system_mix 
                        }
                        if(res.data.server_protection!=null&&res.data.server_protection!=''){// 服务器安全防护:不必要的应用、服务、端口
                            that.serve = res.data.server_protection 
                        }
                        if(res.data.server_account!=null&&res.data.server_account!=''){// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                            that.set_one = res.data.server_account 
                        }
                        if(res.data.server_scan!=null&&res.data.server_scan!=''){// 服务器安全防护:扫描、病毒木马监测
                            that.scan_one = res.data.server_scan 
                        }
                        if(res.data.network_protection!=null&&res.data.network_protection!=''){// 网络设备防护:安全策略配置
                            that.defend = res.data.network_protection 
                        }
                        if(res.data.network_account!=null&&res.data.network_account!=''){// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                            that.set_two = res.data.network_account 
                        }
                        if(res.data.network_scan!=null&&res.data.network_scan!=''){// 网络设备防护:扫描、病毒木马监测
                            that.scan_two = res.data.network_scan 
                        }
                        if(res.data.safety!=null&&res.data.safety!=''){// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                            that.deploy = res.data.safety 
                        }
                        if(res.data.policy!=null&&res.data.policy!=''){// 信息安全设备部署及使用:安全策略配置
                            that.deploy_two = res.data.policy 
                        }
                        if(res.data.computer!=null&&res.data.computer!=''){// 终端计算机安全管理方式
                            that.way = res.data.computer 
                        }
                        if(res.data.account_token!=null&&res.data.account_token!=''){// 账户口令管理
                            that.word = res.data.account_token 
                        }
                        if(res.data.net_safe!=null&&res.data.net_safe!=''){// 接入互联网安全控制措施
                            that.measure = res.data.net_safe 
                        }
                        if(res.data.mixing!=null&&res.data.mixing!=''){// 在非涉密信息系统和涉密信息系统混合使用情况
                            that.mingle = res.data.mixing 
                        }
                        if(res.data.scanning!=null&&res.data.scanning!=''){// 漏洞扫描木马检测
                            that.scan = res.data.scanning 
                        }
                        if(res.data.classified!=null&&res.data.classified!=''){// 是否存在使用非涉密计算计算机处理涉密信息情况
                            if(res.data.classified == 0){
                                that.existIndex = 1 
                            }else{
                                that.existIndex = 2
                                that.exist = res.data.classified 
                            }
                        }

                        if(res.data.plan_record!=null&&res.data.plan_record!=''){// 应急预案制定及备案情况
                            that.enact = res.data.plan_record 
                        }
                        if(res.data.support_team!=null&&res.data.support_team!=''){// 应急技术支援队伍
                            that.skill = res.data.support_team 
                        }
                        if(res.data.backup_data!=null&&res.data.backup_data!=''){// 重要数据
                            that.wd = res.data.backup_data 
                        }
                        if(res.data.backup_sys!=null&&res.data.backup_sys!=''){// 重要信息系统
                            that.lineage = res.data.backup_sys 
                        }
                        

                        if(res.data.is_train!=null&&res.data.is_train!=''){// 参加培训情况
                            that.trainIndex = res.data.is_train // 参加培训情况
                            that.attend = res.data.people // 本年度是否派员参加信息安全相关业务培训，人/次数
                            that.branch = res.data.train_name // 培训部门名称
                        }
                        if(res.data.start_train!=null&&res.data.start_train!=''){// 组织培训情况
                            if(res.data.start_train==0){
                                that.tissueIndex = res.data.start_train // 组织培训情况
                            }else{
                                that.tissueIndex = 1
                                that.tissue = res.data.start_train // 组织培训情况
                            }
                        }
                        that.ratio = res.data.ratio // 参训人员比例

                        that.virus = res.data.virusfree_servers // 进行过病毒木马等恶意代码检查服务器的台数
                        that.infection = res.data.virus_servers // 其中感染恶意代码的服务器台数
                        that.viciousness = res.data.virusfree_computer // 进行过病毒木马等恶意代码检测的终端计算机台数
                        that.venom = res.data.virus_computer // 其中感染恶意代码的终端计算机台数
                        that.flaw = res.data.scanned_servers // 进行过漏洞扫描的服务器台数
                        that.loophole = res.data.vulnerable_servers // 其中存在漏洞的服务器台数
                        that.defect = res.data.highrisk_servers // 其中存在高风险漏洞的服务器台数
                        that.leak = res.data.scanned_computer // 进行过漏洞扫描的终端计算机台数
                        that.hole = res.data.vulnerable_computer // 其中存在漏洞的终端计算器台数
                        that.high_risk = res.data.highrisk_computer // 其中存在高风险漏洞的终端计算器台数
                        that.spite = res.data.tamper_number // 门户网站网页被篡改（内含嵌恶意代码）次数
                        that.use = res.data.process_number // 使用非涉密终端计算机处理涉密信息事件数
                        that.system = res.data.mixed_number // 终端计算器在非涉密系统和涉密系统间混用事件数
                        that.shift = res.data.storage_mixed // 移动存储介质在非涉密系统和涉密系统间交叉使用事件数
                        
                        if(res.data.is_pass!=null&&res.data.is_pass!=''){// 信息安全管理体系认证情况
                            if(res.data.is_pass == 0){
                                that.attestationIndex = 2 
                            }else{
                                that.attestationIndex = 1
                                that.attestation = res.data.is_pass
                            }
                        }
                    }
                }) 
            },
            // 获取审批后详情
            getDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        if(res.data.is_system!=null&&res.data.is_system!=''){// 岗位信息安全和保密责任制度
                            that.duty = res.data.is_system 
                        }
                        if(res.data.is_nda!=null&&res.data.is_nda!=''){// 重要岗位人员信息安全和保密协议
                            that.agreement = res.data.is_nda 
                        }
                        if(res.data.is_safety!=null&&res.data.is_safety!=''){// 人员离岗离职安全管理规定
                            that.dimission = res.data.is_safety 
                        }
                        if(res.data.safety_manage!=null&&res.data.safety_manage!=''){// 信息安全设备运维管理
                            that.facility = res.data.safety_manage 
                        }
                        if(res.data.plant_manage!=null&&res.data.plant_manage!=''){// 设备维修维护和报废销毁管理
                            that.destroy = res.data.plant_manage 
                        }
                        if(res.data.areas!=null&&res.data.areas!=''){// 网络区域划分是否合理
                            that.area = res.data.areas 
                        }
                        if(res.data.safety_eq!=null&&res.data.safety_eq!=''){//  安全防护设备策略
                            that.tactics = res.data.safety_eq 
                        }
                        if(res.data.access!=null&&res.data.access!=''){// 互联网访问控制
                            that.control = res.data.access 
                        }
                        if(res.data.is_log!=null&&res.data.is_log!=''){// 互联网访问日志
                            that.log = res.data.is_log 
                        }
                        that.org = res.data.domain // 域名
                        that.address = res.data.ip // IP地址
                        if(res.data.web_record!=null&&res.data.web_record!=''){// 网站是否备案
                            that.file = res.data.web_record 
                        }
                        if(res.data.account!=null&&res.data.account!=''){// 门户网站账户安全管理
                            that.account = res.data.account 
                        }
                        if(res.data.clear!=null&&res.data.clear!=''){// 清理网站临时文件、关闭网站目录遍历功能等清理
                            that.clear = res.data.clear 
                        }
                        if(res.data.website!=null&&res.data.website!=''){// 门户网站信息发布管理
                            that.issue = res.data.website 
                        }
                        if(res.data.memory!=null&&res.data.memory!=''){// 移动储蓄设备管理方式
                            that.savings = res.data.memory 
                        }
                        if(res.data.system_mix!=null&&res.data.system_mix!=''){// 在非涉密信息系统和涉密信息系统间混用情况
                            that.blended = res.data.system_mix 
                        }
                        if(res.data.server_protection!=null&&res.data.server_protection!=''){// 服务器安全防护:不必要的应用、服务、端口
                            that.serve = res.data.server_protection 
                        }
                        if(res.data.server_account!=null&&res.data.server_account!=''){// 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                            that.set_one = res.data.server_account 
                        }
                        if(res.data.server_scan!=null&&res.data.server_scan!=''){// 服务器安全防护:扫描、病毒木马监测
                            that.scan_one = res.data.server_scan 
                        }
                        if(res.data.network_protection!=null&&res.data.network_protection!=''){// 网络设备防护:安全策略配置
                            that.defend = res.data.network_protection 
                        }
                        if(res.data.network_account!=null&&res.data.network_account!=''){// 网络设备防护:账户口令设置8位，包含数字、字母或符号
                            that.set_two = res.data.network_account 
                        }
                        if(res.data.network_scan!=null&&res.data.network_scan!=''){// 网络设备防护:扫描、病毒木马监测
                            that.scan_two = res.data.network_scan 
                        }
                        if(res.data.safety!=null&&res.data.safety!=''){// 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                            that.deploy = res.data.safety 
                        }
                        if(res.data.policy!=null&&res.data.policy!=''){// 信息安全设备部署及使用:安全策略配置
                            that.deploy_two = res.data.policy 
                        }
                        if(res.data.computer!=null&&res.data.computer!=''){// 终端计算机安全管理方式
                            that.way = res.data.computer 
                        }
                        if(res.data.account_token!=null&&res.data.account_token!=''){// 账户口令管理
                            that.word = res.data.account_token 
                        }
                        if(res.data.net_safe!=null&&res.data.net_safe!=''){// 接入互联网安全控制措施
                            that.measure = res.data.net_safe 
                        }
                        if(res.data.mixing!=null&&res.data.mixing!=''){// 在非涉密信息系统和涉密信息系统混合使用情况
                            that.mingle = res.data.mixing 
                        }
                        if(res.data.scanning!=null&&res.data.scanning!=''){// 漏洞扫描木马检测
                            that.scan = res.data.scanning 
                        }
                        if(res.data.classified!=null&&res.data.classified!=''){// 是否存在使用非涉密计算计算机处理涉密信息情况
                            if(res.data.classified == 0){
                                that.existIndex = 1 
                            }else{
                                that.existIndex = 2
                                that.exist = res.data.classified 
                            }
                        }

                        if(res.data.plan_record!=null&&res.data.plan_record!=''){// 应急预案制定及备案情况
                            that.enact = res.data.plan_record 
                        }
                        if(res.data.support_team!=null&&res.data.support_team!=''){// 应急技术支援队伍
                            that.skill = res.data.support_team 
                        }
                        if(res.data.backup_data!=null&&res.data.backup_data!=''){// 重要数据
                            that.wd = res.data.backup_data 
                        }
                        if(res.data.backup_sys!=null&&res.data.backup_sys!=''){// 重要信息系统
                            that.lineage = res.data.backup_sys 
                        }
                        

                        if(res.data.is_train!=null&&res.data.is_train!=''){// 参加培训情况
                            that.trainIndex = res.data.is_train // 参加培训情况
                            that.attend = res.data.people // 本年度是否派员参加信息安全相关业务培训，人/次数
                            that.branch = res.data.train_name // 培训部门名称
                        }
                        if(res.data.start_train!=null&&res.data.start_train!=''){// 组织培训情况
                            if(res.data.start_train==0){
                                that.tissueIndex = res.data.start_train // 组织培训情况
                            }else{
                                that.tissueIndex = 1
                                that.tissue = res.data.start_train // 组织培训情况
                            }
                        }
                        that.ratio = res.data.ratio // 参训人员比例

                        that.virus = res.data.virusfree_servers // 进行过病毒木马等恶意代码检查服务器的台数
                        that.infection = res.data.virus_servers // 其中感染恶意代码的服务器台数
                        that.viciousness = res.data.virusfree_computer // 进行过病毒木马等恶意代码检测的终端计算机台数
                        that.venom = res.data.virus_computer // 其中感染恶意代码的终端计算机台数
                        that.flaw = res.data.scanned_servers // 进行过漏洞扫描的服务器台数
                        that.loophole = res.data.vulnerable_servers // 其中存在漏洞的服务器台数
                        that.defect = res.data.highrisk_servers // 其中存在高风险漏洞的服务器台数
                        that.leak = res.data.scanned_computer // 进行过漏洞扫描的终端计算机台数
                        that.hole = res.data.vulnerable_computer // 其中存在漏洞的终端计算器台数
                        that.high_risk = res.data.highrisk_computer // 其中存在高风险漏洞的终端计算器台数
                        that.spite = res.data.tamper_number // 门户网站网页被篡改（内含嵌恶意代码）次数
                        that.use = res.data.process_number // 使用非涉密终端计算机处理涉密信息事件数
                        that.system = res.data.mixed_number // 终端计算器在非涉密系统和涉密系统间混用事件数
                        that.shift = res.data.storage_mixed // 移动存储介质在非涉密系统和涉密系统间交叉使用事件数
                        
                        if(res.data.is_pass!=null&&res.data.is_pass!=''){// 信息安全管理体系认证情况
                            if(res.data.is_pass == 0){
                                that.attestationIndex = 2 
                            }else{
                                that.attestationIndex = 1
                                that.attestation = res.data.is_pass
                            }
                        }
                    }
                })
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
            // 文档上传
            uploadFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],i)
                }
            },
            // 上传
            uploadData(pdf,i){
                const that = this
                that.imgData = new FormData()
                // that.imgData.append('catalog','bourse')
                // 
                // that.imgData.append('name','images')
                that.imgData.append('type','2')
                that.imgData.append('file',pdf)
                that.imgData.append('id',that.user.id)
                console.log('*********1',that.imgData)
                that.$request({
                    that: that,
                    api: that.$api.putForms,
                    data: that.imgData,
                    headers: { 'content-type': 'multipart/form-data'},
                    discardSign: true,
                    loading: true,
                    success(res){
                        that.$dialog.toast({
                            mes: '上传成功',
                            timeout: 1500,
                            icon: 'success',
                        })
                        that.duty = '' // 岗位信息安全和保密责任制度
                        that.agreement = '' // 重要岗位人员信息安全和保密协议
                        that.dimission = '' // 人员离岗离职安全管理规定
                        that.facility = '' // 信息安全设备运维管理
                        that.destroy = '' // 设备维修维护和报废销毁管理
                        that.area = '' // 网络区域划分是否合理
                        that.tactics = '' // 安全防护设备策略
                        that.control = '' // 互联网访问控制
                        that.log = '' // 互联网访问日志
                        that.org = '' // 域名
                        that.address = '' // IP地址
                        that.file = '' // 网站是否备案
                        that.account = '' // 门户网站账户安全管理
                        that.clear = '' // 清理网站临时文件、关闭网站目录遍历功能等清理
                        that.issue = '' // 门户网站信息发布管理
                        that.savings = '' // 移动储蓄设备管理方式
                        that.blended = '' // 在非涉密信息系统和涉密信息系统间混用情况
                        that.serve = '' // 服务器安全防护:不必要的应用、服务、端口
                        that.set_one = '' // 服务器安全防护:账户口令设置8位，包含数字、字母或符号
                        that.scan_one = '' // 服务器安全防护:扫描、病毒木马监测
                        that.defend = '' // 网络设备防护:安全策略配置
                        that.set_two = '' // 网络设备防护:账户口令设置8位，包含数字、字母或符号
                        that.scan_two = '' // 网络设备防护:扫描、病毒木马监测
                        that.deploy = '' // 信息安全设备部署及使用:防病毒、防火墙、入侵检测、安全审计等功能的设备
                        that.deploy_two = '' // 信息安全设备部署及使用:安全策略配置
                        that.way = '' // 终端计算机安全管理方式
                        that.word = '' // 账户口令管理
                        that.measure = '' // 接入互联网安全控制措施
                        that.mingle = '' // 在非涉密信息系统和涉密信息系统混合使用情况
                        that.scan = '' // 漏洞扫描木马检测
                        that.existIndex = ''// 是否存在使用非涉密计算计算机处理涉密信息情况
                        that.exist = ''// 是否存在使用非涉密计算计算机处理涉密信息情况
                        that.enact = '' // 应急预案制定及备案情况
                        that.skill = '' // 应急技术支援队伍
                        that.wd = '' // 重要数据
                        that.lineage = '' // 重要信息系统
                        that.trainIndex = 0 // 参加培训情况
                        that.attend = '' // 本年度是否派员参加信息安全相关业务培训，人/次数
                        that.branch = '' // 培训部门名称
                        that.tissueIndex = 0 // 组织培训情况
                        that.tissue = '' // 组织培训情况
                        that.ratio = '' // 参训人员比例
                        that.virus = '' // 进行过病毒木马等恶意代码检查服务器的台数
                        that.infection = '' // 其中感染恶意代码的服务器台数
                        that.viciousness = '' // 进行过病毒木马等恶意代码检测的终端计算机台数
                        that.venom = '' // 其中感染恶意代码的终端计算机台数
                        that.flaw = '' // 进行过漏洞扫描的服务器台数
                        that.loophole = '' // 其中存在漏洞的服务器台数
                        that.defect = '' // 其中存在高风险漏洞的服务器台数
                        that.leak = '' // 进行过漏洞扫描的终端计算机台数
                        that.hole = '' // 其中存在漏洞的终端计算器台数
                        that.high_risk = '' // 其中存在高风险漏洞的终端计算器台数
                        that.spite = '' // 门户网站网页被篡改（内含嵌恶意代码）次数
                        that.use = '' // 使用非涉密终端计算机处理涉密信息事件数
                        that.system = '' // 终端计算器在非涉密系统和涉密系统间混用事件数
                        that.shift = '' // 移动存储介质在非涉密系统和涉密系统间交叉使用事件数
                        that.attestationIndex = '' // 信息安全管理体系认证情况
                        that.attestation = '' // 信息安全管理体系认证情况
                        that.getDraft()
                        console.log('打印本次结果：',res)
                        // console.log('打印本次上传的图片路径：',res.data)
                        // that.supplier_info = res.data.src
                        // console.log('打印查看',that.atlas)
                    },
                    fail(err) {
                        console.log(err)
                        that.$dialog.alert({
                            mes:'上传失败'
                        });
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
            that.isType = that.$route.query.type
            if(that.$route.query.type==2){
                that.getDetails()// 获取审批后详情
            }else{
                that.getDraft()// 获取保存草稿
            }
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/safety.vue